import styled from "@emotion/styled";

const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
`;

export default Cards;
